import { translatePhrases } from '@elfsight/lib-translator';
import type { LanguageCode } from '../../types';

type TranslateDocumentTitleProps = {
  sourceLanguage: string | undefined;
  targetLanguage: LanguageCode;
  widgetToken: string | undefined;
};

export async function translateDocumentTitle({
  sourceLanguage,
  targetLanguage,
  widgetToken
}: TranslateDocumentTitleProps) {
  const title = document.title;

  if (!title) {
    return;
  }

  const translatedTitle = await translatePhrases({
    phrases: [title],
    params: {
      sourceLanguage,
      targetLanguage,
      widgetToken
    }
  });

  document.title = translatedTitle[0];
}
